import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const partnerDetailsApi = createAsyncThunk(
    'auth/partners/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.partnersAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const partnerDetailsSlice = createSlice({
    name: 'partner details',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetpartner: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(partnerDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(partnerDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(partnerDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetpartner } = partnerDetailsSlice.actions;
export const partnerDetailsReducer = partnerDetailsSlice.reducer